import { Classes, Dialog } from "@blueprintjs/core";
import React from "react";
import styles from "./PlanHelpDialog.module.scss";

interface PlanHelpDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

interface HelpRow {
    gesture: string;
    action: string;
}

const FILLING: HelpRow[] = [
    { gesture: "Двойной клик по дню", action: "назначить проект: на день, на весь блок или на выделение" },
    { gesture: "Рамка левой кнопкой", action: "выделить отрезок свободных дней" },
    { gesture: "Рамка средней кнопкой", action: "выделить часть дней внутри заполненного блока" },
    { gesture: "Enter", action: "назначить проект на выделение" },
];

const MOVING: HelpRow[] = [
    { gesture: "Тянуть блок", action: "переставить на другие дни или отдать другому сотруднику" },
    { gesture: "Ctrl + тянуть блок", action: "скопировать вместо переноса" },
    { gesture: "Тянуть правый край", action: "продлить работы; упёрлись в соседа — он и цепочка за ним уедут вправо" },
    { gesture: "Тянуть левый край", action: "сдвинуть начало работ; сосед слева при этом перезаписывается" },
];

const MENU: HelpRow[] = [
    { gesture: "Правый клик", action: "копировать, вставить, очистить, отменить действие" },
    { gesture: "Вставить со сдвигом", action: "раздвинуть дни: блок, в середину которого попали, разрежется" },
    { gesture: "Очистить со сдвигом", action: "убрать дни и подтянуть к ним всё, что стояло правее" },
    { gesture: "Esc", action: "отменить все несохранённые правки" },
];

const Section = ({ title, rows }: { title: string; rows: HelpRow[] }) => (
    <div className={styles.section}>
        <div className={styles.title}>{title}</div>

        {rows.map((row) => (
            <div key={row.gesture} className={styles.row}>
                <div className={styles.gesture}>{row.gesture}</div>
                <div className={styles.action}>{row.action}</div>
            </div>
        ))}
    </div>
);

export const PlanHelpDialog: React.FC<PlanHelpDialogProps> = ({ isOpen, onClose }) => (
    <Dialog
        title="Инструкция по работе"
        isOpen={isOpen}
        onClose={onClose}
        backdropClassName="standard"
        className={`${styles.dialog} figma-dialog`}
    >
        <div className={Classes.DIALOG_BODY}>
            <Section title="Заполнение" rows={FILLING} />
            <Section title="Перенос и сроки" rows={MOVING} />
            <Section title="Контекстное меню" rows={MENU} />
        </div>
    </Dialog>
);
